import number1 from '../assets/icons/number1.svg'
import number2 from '../assets/icons/number2.svg'
import number3 from '../assets/icons/number3.svg'
import number4 from '../assets/icons/number4.svg'
import number3Red from '../assets/icons/number3-red.svg'

const allQuestion = [
  {
    id: 'age',
    question: 'What is your age?',
    dataType: 'text',
    label: 'Enter your age',
    nextButtonEnabled: true,
    type: 'PNDS | SCORED',
  },
  {
    id: 'height',
    question: 'What is your height (centimeters)?',
    dataType: 'text',
    label: 'Enter your height',
    nextButtonEnabled: true,
    type: 'PNDS',
  },
  {
    id: 'weight',
    question: 'What is your weight (Kg)?',
    dataType: 'text',
    label: 'Enter your weight',
    nextButtonEnabled: true,
    type: 'PNDS',
  },
  {
    id: 'daily_activity',
    question: 'What is the type of your daily activity?',
    options: [
      {
        value: 'Sedentary',
        label: 'Sedentary',
        id: 'Sedentary',
        score: 1,
      },
      {
        value: 'Light',
        label: 'Light',
        id: 'Light',
        score: 2,
      },
      {
        value: 'Moderate',
        label: 'Moderate',
        id: 'Moderate',
        score: 3,
      },
      {
        value: 'Active',
        label: 'Active',
        id: 'Active',
        score: 4,
      },
      {
        value: 'Very Active',
        label: 'Very Active',
        id: 'Very Active',
        score: 5,
      },
    ],
    nextButtonEnabled: false,
    type: 'PNDS',
  },
  {
    id: 'gender',
    question: 'What is your gender?',
    options: [
      { value: 'Male', label: 'Male', id: 'Male', score: 1 },
      { value: 'Female', label: 'Female', id: 'Female', score: 2 },
    ],
    nextButtonEnabled: false,
    type: 'PNDS | SCORED',
  },
  {
    id: 'comorbid_condition',
    question: 'Do you have another comorbid condition?',
    options: [
      { value: 'Diabetes', label: 'Diabetes', id: 'Diabetes', score: 1 },
      {
        value: 'Hypertension',
        label: 'Hypertension',
        id: 'Hypertension',
        score: 1,
      },
      {
        value: 'Cardiovascular Disease',
        label: 'Cardiovascular Disease',
        id: 'Cardiovascular Disease',
        score: 1,
      },
      { value: 'CKD', label: 'CKD', id: 'CKD', score: 1 },
      { value: 'NAFLD', label: 'NAFLD', id: 'NAFLD', score: 1 },
      { value: 'COPD', label: 'COPD', id: 'COPD', score: 1 },
      { value: 'Asthma', label: 'Asthma', id: 'Asthma', score: 1 },
      {
        value: 'No comorbidity',
        label: 'No comorbidity',
        id: 'No comorbidity',
        score: 0,
      },
    ],
    // dataType: 'multi-select',
    // nextButtonEnabled: true,
    type: 'PNDS',
  },
  {
    id: 'comorbidities',
    question: 'Mention any history of comorbidities',
    options: [
      {
        value: 'Hypertension',
        label: 'Hypertension',
        id: 'Hypertension',
        score: 1,
      },
      {
        value: 'Anemia',
        label: 'Anemia',
        id: 'Anemia',
        score: 1,
      },
      {
        value: 'Proteinuria',
        label: 'Proteinuria',
        id: 'Proteinuria',
        score: 1,
      },
      {
        value: 'Heart attack or Stroke',
        label: 'Heart attack or Stroke',
        id: 'Heart attack or Stroke',
        score: 1,
      },
      {
        value: 'Congestive heart failure or Heart failure',
        label: 'Congestive heart failure or Heart failure',
        id: 'Congestive heart failure or Heart failure',
        score: 2,
      },
      {
        value: 'No Past History/ No comorbidity',
        label: 'No Past History/ No comorbidity',
        id: 'No Past History/ No comorbidity',
        score: 2,
      },
    ],
    dataType: 'multi-select',
    nextButtonEnabled: true,
    type: 'SCORED',
  },
]

export const cardsDatas = [
  {
    header: {
      title: 'Grade A',
      icon: number1,
      titleColor: 'text-text-accent-teal-primary',
    },
    descriptions: [
      {
        title: 'Ideal Choice',
        desc: '✅ Best for your health! Nutritionally balanced, rich in essential nutrients, and safe for regular consumption',
      },
    ],
  },
  {
    header: {
      title: 'Grade B',
      icon: number2,
      iconClass: '',
      titleColor: 'text-text-accent-indigo-primary',
    },
    descriptions: [
      {
        title: 'Good Choice',
        desc: '✅ Still a healthy option but may require slight moderation due to calories, fats, or sugar content.',
      },
    ],
  },
  {
    header: {
      title: 'Grade C',
      icon: number3,
      iconClass: '',
      titleColor: 'text-text-accent-gold-primary',
    },
    descriptions: [
      {
        title: 'Consume with Caution',
        desc: '⚠ May have high calories, unhealthy fats, or restricted nutrients (e.g., excess sodium or potassium for CKD patients). Consider portion control or alternatives.',
      },
    ],
  },
  {
    header: {
      title: 'Grade D',
      icon: number4,
      iconClass: '',
      titleColor: 'text-text-accent-teal-primary',
    },
    descriptions: [
      {
        title: 'Avoid or Limit',
        desc: '🚫 High in sugars, unhealthy fats, or restricted nutrients that may impact your health negatively. Best to replace with a healthier option.',
      },
    ],
  },
]

export const kidneyScorecardsData = [
  {
    header: {
      title: '81 - 100',
      icon: number1,
      titleColor: 'text-text-accent-teal-primary',
    },
    descriptions: [
      {
        title: 'Low Risk',
        desc: 'Your kidney health looks good, with no significant risk of CKD. Maintain a healthy lifestyle to stay on track.',
      },
    ],
  },
  {
    header: {
      title: '51 - 80',
      icon: number2,
      iconClass: '',
      titleColor: 'text-text-accent-indigo-primary',
    },
    descriptions: [
      {
        title: 'Moderate Risk (At Risk for CKD)',
        desc: 'You are at some risk of CKD. It’s recommended to consult a specialist for early intervention.',
      },
    ],
  },
  {
    header: {
      title: '00 - 50',
      icon: number3Red,
      iconClass: '',
      titleColor: 'text-text-accent-gold-primary',
    },
    descriptions: [
      {
        title: 'High Risk (At Risk for CKD)',
        desc: 'Your kidney health is at high risk, with a significant likelihood of CKD. Seek medical advice immediately',
      },
    ],
  },
]

export const healthConditionMap = {
  CKD: 'chronic kidney disease',
  Diabetes: 'diabetes',
  Hypertension: 'hypertension',
  'Cardiovascular Disease': 'cardiovascular disease',
  NAFLD: 'non-alcoholic fatty liver disease',
  COPD: 'chronic obstructive pulmonary',
  Asthma: 'asthma',
  'No comorbidity': 'No comorbidity',
}

export default allQuestion
